import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { getServiceAgesLabel } from 'Components/utils/product/product.utils';
import { t } from 'Src/i18n';
import { Capsule } from 'Components/frameworks/capsule/Capsule';
import { CollapsePanel } from 'Components/frameworks/collapse-panel/CollapsePanel';
import { Icon } from 'Components/frameworks/icon/Icon';
const EQUIPMENT_ID_MAPPING = {
  ACT_CANC_CHILD_baby_sitting: ICONS.BABYSITTING,
  ACT_CANC_CHILD_pyjamas_club: ICONS.PAJAMAS,
  ACT_CANC_CHILD_teen_spa: ICONS.SPA,
  ACT_CANC_CHILD_swimming_lessons: ICONS.SWIMMINGPOOL,
  ACT_CANC_CHILD_pleasures_of_snow_course: ICONS.SKI,
};
type Props = {
  activities: Product['childrenActivities'];
  isSeller?: boolean;
};
export const ChildcareOnDemandEquipmentCapsule = ({ activities, isSeller }: Props) => (
  <Capsule
    className="mb-100"
    color="#924833"
    header="large"
    label={t('booking.childcarePopIn.onDemandChildcare')}
  >
    <p className="p-20 text-14 font-bold">
      {t(
        isSeller
          ? 'booking.partners.services.childcare.additionalServicesReassuranceMessage'
          : 'booking.services.childcare.additionalServicesReassuranceMessage',
      )}
    </p>
    {activities.map((activity) => (
      <div className="border-t-1 border-lightGrey font-bold" key={activity.id}>
        <CollapsePanel
          collapseIconName={ICONS.ARROW_DOWN}
          expandIconName={ICONS.ARROW_DOWN}
          theme="limpidSmall"
          title={
            <span className="flex items-center gap-15 text-14 font-bold text-sienna">
              <Icon
                className="shrink-0"
                name={EQUIPMENT_ID_MAPPING[activity.id] || ICONS.TRIDENT1}
                width="1.875rem"
              />
              <span>
                {activity.label}
                {!!activity.ageInMonths && (
                  <span className="block text-12 font-normal text-black">
                    {getServiceAgesLabel(activity.ageInMonths)}
                  </span>
                )}
              </span>
            </span>
          }
        >
          <p className="p-20 pt-0 text-14 font-normal leading-tight">{activity.description}</p>
        </CollapsePanel>
      </div>
    ))}
  </Capsule>
);
